import isEmpty from 'lodash/isEmpty';
import { isValidUrl } from '@jira/platform__is-url/src/index.tsx';
import { isValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';

export const allowedSchemes: string[] = ['http:', 'https:'];

interface ApplinksValidationError extends Error {
	summary: string;
	details: string;
}

export const formatBackendError = (maybeError: Error | undefined, fallback: string): string => {
	if (maybeError && isValidationError(maybeError)) {
		// Show the first validation error message
		if (maybeError.errors.length > 0) {
			try {
				const firstError = maybeError.errors[0].error;

				// oxlint-disable-next-line typescript/consistent-type-assertions
				return (firstError as unknown as ApplinksValidationError).summary || fallback;
			} catch (e) {
				return fallback;
			}
		}
	}
	if (maybeError instanceof Error) {
		return maybeError.message || fallback;
	}
	return fallback;
};

export const validateURLField = (
	value: string | undefined,
	isRequired: boolean,
	checkScheme: boolean,
): string | undefined => {
	if (!value) {
		return isRequired ? validationErrorMessages.empty : undefined;
	}
	const trimmedValue = value?.trim();
	if (isEmpty(trimmedValue) && isRequired) {
		return validationErrorMessages.empty;
	}

	if (!isEmpty(trimmedValue) && !isValidUrl(value)) {
		return validationErrorMessages.urlInvalid;
	}
	if (checkScheme && !allowedSchemes.some((scheme) => value.startsWith(scheme))) {
		return validationErrorMessages.urlSchemeInvalid;
	}

	return undefined;
};

export const validateSupportedScopes = (
	chosenScopes: string[],
	supportedScopes: string[],
): string | undefined => {
	const invalidScopes = chosenScopes.filter((scope) => !supportedScopes.includes(scope));
	if (invalidScopes.length > 0) {
		return validationErrorMessages.unsupportedScope;
	}

	return undefined;
};

export const validationErrorMessages = {
	empty: 'This field is required.',
	urlInvalid: 'Enter a valid URL.',
	urlSchemeInvalid: 'The URL must start with http:// or https://.',
	authTypeInvalid: 'Select a valid authentication type.',
	impersonationNotAllowed:
		'2LO (impersonation) is deprecated. Please choose another authentication type.',
	unsupportedScope: 'One or more selected scopes are not supported.',
};
